import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_submit_stock_take_report: { message: "idle" },
};

export const tenant_submit_stock_take_report_Slice = createSlice({
 name: "tenant_submit_stock_take_report",
 initialState,
 reducers: {
  success_tenant_submit_stock_take_report: (state, action) => {
   state.tenant_submit_stock_take_report = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_submit_stock_take_report: (state, action) => {
   state.tenant_submit_stock_take_report = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_submit_stock_take_report: (state) => {
   state.tenant_submit_stock_take_report = { status: app_consts.IDLE };
  },
  loading_tenant_submit_stock_take_report: (state) => {
   state.tenant_submit_stock_take_report = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_submit_stock_take_report, fail_tenant_submit_stock_take_report, reset_tenant_submit_stock_take_report, loading_tenant_submit_stock_take_report } = tenant_submit_stock_take_report_Slice.actions;

export default tenant_submit_stock_take_report_Slice.reducer;